import { BaseDto } from '@/shared/dtos/base-dto';

export class centros extends BaseDto {
    public nombre !: string;
    public direccion !: string;
    public longitud !: string;
    public latitud !: string;
    public codigo_sucursal !: number;

    public id_grupo !: number;
    public grupo !: any;
} 
